import { api } from "../base";

interface OrgData {
  org_id: string;
  display_name?: string;
}

interface OrgResponse {
  data?: OrgData[];
}

const orgEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    /** Returns the first org_id for the authenticated user. */
    getOrg: build.query<OrgData | null, void>({
      query: () => ({ url: "/api/account/v1/orgs" }),
      transformResponse: (response: OrgResponse) =>
        response?.data?.[0] ?? null,
      providesTags: ["OrgMetadata"],
    }),

    /** Fetches org-level metadata (portfolios, users, etc.) for a given org. */
    getOrgMetadata: build.query<Record<string, unknown>, string>({
      query: (orgId) => ({ url: `/api/account/v1/orgs/${orgId}/metadata` }),
      providesTags: ["OrgMetadata"],
    }),

    /** Fetches users for an org. */
    getOrgUsers: build.query<unknown[], string>({
      query: (orgId) => ({ url: `/api/account/v1/orgs/${orgId}/users` }),
      providesTags: ["OrgUsers"],
    }),
  }),
});

export const {
  useGetOrgQuery,
  useLazyGetOrgQuery,
  useGetOrgMetadataQuery,
  useGetOrgUsersQuery,
  useLazyGetOrgUsersQuery,
} = orgEndpoints;
